import wretch from 'wretch';
import QueryStringAddon from 'wretch/addons/queryString';

const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;

export const http = wretch(BASE_API_URL)
  .options({ credentials: 'include', mode: 'cors' })
  .addon(QueryStringAddon);
